import { useState } from 'react';
import { useSelector } from 'react-redux';
import { deleteCredencialRdp } from '../../helpers/api_helper';

const useDeleteCredencialRdp = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const deleteCredencialRdpHook = async (id) => {
        setLoading(true);
        setError(null);
        try {
            const response = await deleteCredencialRdp(tenantId, id);
            return response;
        } catch (err) {
            const errorMessage = `Failed to delete Credencial RDP: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { deleteCredencialRdp: deleteCredencialRdpHook, loading, error };
};

export default useDeleteCredencialRdp;
